<template>
  <CommonTabs
    :id="$props.id"
    resource="groups"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'groups' }"
    :tab.sync="tab"
    v-on:update:tab="val => (tab = val)"
    :breadcrumbs="breadcrumbs"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../../../components/common/tabs/CommonTabs";
import NewGroup from "../../../components/projects/metering/groups/NewGroup";
import EditGroup from "../../../components/projects/metering/groups/EditGroup";
import DeleteGroup from "../../../components/projects/metering/groups/DeleteGroup";
import ChildrenGroup from "../../../components/projects/metering/groups/ChildrenGroup";
import AttachedContactsGroup from "../../../components/projects/metering/groups/AttachedContactsGroup";
import MetersGroup from "../../../components/projects/metering/groups/MetersGroup";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";

export default {
  name: "Group",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      NewGroup,
      EditGroup,
      DeleteGroup,
      AttachedContactsGroup,
      ChildrenGroup,
      MetersGroup
    },
    tab: 0
  }),
  computed: {
    tabs() {
      if (!this.$props.id) {
        return [
          {
            component: "NewGroup",
            title: "create"
          }
        ];
      } else {
        return [
          {
            component: "EditGroup",
            title: "edit"
          },
          {
            component: "AttachedContactsGroup",
            title: "attached-contacts",
            tabClass: {
              "tab-item-full-width": true,
              "tab-item-padding-0": true
            }
          },
          {
            component: "ChildrenGroup",
            title: "children",
            tabClass: {
              "tab-item-full-width": true,
              "tab-item-padding-0": true
            }
          },
          {
            component: "MetersGroup",
            title: "meters",
            tabClass: {
              "tab-item-full-width": true,
              "tab-item-padding-0": true
            }
          },
          {
            component: "DeleteGroup",
            title: "delete"
          }
        ];
      }
    },
    group() {
      return this.$store.getters["projectMeteringStore/groupStore/getItem"];
    },
    breadcrumbs() {
      return this.group.id
        ? [
            {
              text: this.$t("groups.groups"),
              to: {
                name: "groups",
                params: {
                  project_id: this.project.id
                }
              },
              exact: true
            },
            {
              text: this.group.name,
              to: {
                name: "group",
                params: {
                  project_id: this.project.id,
                  id: this.group.id
                }
              },
              exact: true
            }
          ]
        : [];
    }
  },
  methods: {
    getItem() {
      let vm = this;
      if (this.$props.id) {
        this.$store
          .dispatch("projectMeteringStore/groupStore/get", {
            id: this.$props.id,
            project_id: this.$props.project_id
          })
          .then(() => {
            vm.tab = 0;
          });
      } else {
        this.$store.commit("projectMeteringStore/groupStore/set", { item: {} });
      }
    },
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("groups.groups"),
          this.$props.id ? this.group.name : this.$t("groups.create")
        ]
      };
    }
  },
  watch: {
    $props: {
      handler() {
        this.getItem();
      },
      deep: true,
      immediate: true
    },
    group() {
      this.setTitle();
    }
  },
  mounted() {
    this.getItem();
  }
};
</script>
